import { getCpReportTypes } from '@/services/importingJsons.js'

const componentPrognostics = {
  namespaced: true,
  state: {
    selected: {
      customReportLink: null
    },
    reportTypes: {
      error: false,
      loading: false,
      options: []
    }
  },
  mutations: {
    selected (state, payload) {
      state.selected[payload.prop] = payload.value
    },
    reportTypes (state, payload) {
      state.reportTypes[payload.propName] = payload.value
    },
    setDefaultState (state) {
      state.postReport = {
        error: false,
        loading: false,
        response: null
      }
    },
    overwriteSelected (state, newVal) {
      state.selected = newVal
    },
    setDefaultSelectionState (state) {
      state.selected = {
        customReportLink: null
      }
    }
  },
  getters: {
    getAllSelections: state => {
      return state.selected
    }
  },
  actions: {
    updateSelection ({ commit }, payload) {
      if (payload.propName) payload.prop = payload.propName // TODO: Harmonize payload interfaces
      commit('selected', payload)
    },
    loadStateFromFile ({ commit }, data) {
      commit('overwriteSelected', data)
    },
    reset ({ commit }) {
      commit('setDefaultState')
      commit('setDefaultSelectionState')
    },
    getCpReportTypes ({ commit }) {
      commit('reportTypes', { propName: 'options', value: [] })
      commit('reportTypes', { propName: 'error', value: false })
      commit('reportTypes', { propName: 'loading', value: true })

      getCpReportTypes().then(result => {
        commit('reportTypes', { propName: 'options', value: result })
      }).catch(error => {
        console.error('getCpReportTypes:', error)
        commit('reportTypes', { propName: 'error', value: true })
      }).finally(() => {
        commit('reportTypes', { propName: 'loading', value: false })
      })
    },
}}
export default componentPrognostics
